(function(){
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
const GY=window.GY||{};
const FREE=(+GY.free||50)*100;
const MF=String(GY.moneyFormat||'{{amount_with_comma_separator}} €').replace(/<[^>]*>/g,'');
const APOS=String.fromCharCode(39);
function fmtNum(c,d,ts,ds){const p=(c/100).toFixed(d).split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return p[0]+(p[1]?ds+p[1]:'');}
function money(c){c=Math.round(c);return MF.replace(/\{\{\s*(\w+)\s*\}\}/,(m,k)=>{switch(k){case 'amount':return fmtNum(c,2,',','.');case 'amount_no_decimals':return fmtNum(c,0,',','.');case 'amount_no_decimals_with_comma_separator':return fmtNum(c,0,'.',',');case 'amount_with_apostrophe_separator':return fmtNum(c,2,APOS,'.');default:return fmtNum(c,2,'.',',');}});}
const pctOff=(p,c)=>Math.floor((c-p)*100/c);
const esc=s=>String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/'/g,'&#39;');
const store={get(k){try{return JSON.parse(localStorage.getItem(k));}catch(e){return null;}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}};
const design=!!(window.Shopify&&Shopify.designMode);
if(design) document.documentElement.classList.add('shopify-design-mode');
const isCartPage=document.body.classList.contains('template-cart');

// Header
const burger=$('#gyBurger'), menu=$('#gyMenu');
if(burger&&menu){burger.onclick=()=>menu.classList.toggle('open');$$('a',menu).forEach(a=>a.addEventListener('click',()=>menu.classList.remove('open')));}
const hdr=$('.gy-header');
if(hdr){const onS=()=>hdr.classList.toggle('scrolled',scrollY>10);addEventListener('scroll',onS,{passive:true});onS();}

// Reveal
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.08});
$$('.reveal').forEach(el=>io.observe(el));

// Toast
function toast(msg){const t=$('#toast');if(!t)return;t.textContent=msg;t.classList.add('show');clearTimeout(t._t);t._t=setTimeout(()=>t.classList.remove('show'),2400);}

// Cart drawer
const drawer=$('#drawer'),scrim=$('#scrim');
const openCart=()=>{if(!drawer)return;drawer.classList.add('open');scrim.classList.add('show');};
const closeCart=()=>{if(!drawer)return;drawer.classList.remove('open');scrim.classList.remove('show');};
if(drawer){$('#openCart').onclick=openCart;$('#closeCart').onclick=closeCart;scrim.onclick=closeCart;}
addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});
const FALLBACK=`<svg viewBox='0 0 400 400'><use href='#kit'/></svg>`;
function renderCart(c){
  if(!drawer||!c)return;
  $$('.js-cart-count').forEach(e=>e.textContent=c.item_count);
  $('#cartTotal').textContent=money(c.total_price);
  const left=Math.max(0,FREE-c.total_price);
  $('#freeMsg').textContent=left>0?`¡Te faltan ${money(left)} para el envío gratuito!`:'🎉 ¡Tienes envío gratuito!';
  $('#freeFill').style.width=Math.min(100,c.total_price/FREE*100)+'%';
  $('#cartItems').innerHTML=c.items.length?c.items.map(i=>`<div class='ci'><a class='ci-img' href='${esc(i.url)}'>${i.image?`<img src='${esc(i.image)}' alt=''>`:FALLBACK}</a><div class='info'><b>${esc(i.product_title)}</b>${i.variant_title&&!i.product_has_only_default_variant?`<br><small>${esc(i.variant_title)}</small>`:''}<br>${money(i.final_line_price)}<div class='qty'><button data-key='${esc(i.key)}' data-q='${i.quantity-1}' aria-label='Quitar uno'>−</button>${i.quantity}<button data-key='${esc(i.key)}' data-q='${i.quantity+1}' aria-label='Añadir uno'>+</button></div></div></div>`).join(''):`<p class='empty'>Tu carrito está vacío 🌿</p>`;
  $('#checkout').disabled=!c.items.length;
}
const post=(url,body)=>fetch(ROOT+url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
const refresh=()=>fetch(ROOT+'cart.js').then(r=>r.json()).then(renderCart).catch(()=>{});
async function addToCart(id,qty){
  if(!id)return;
  const r=await post('cart/add.js',{items:[{id:+id,quantity:qty||1}]});
  if(!r.ok){const e=await r.json().catch(()=>({}));toast(e.description||'No se pudo añadir el producto');return;}
  if(isCartPage){location.reload();return;}
  await refresh();openCart();toast('Añadido al carrito ✓');
}
if(drawer){
  $('#cartItems').onclick=async e=>{const b=e.target.closest('button');if(!b)return;const r=await post('cart/change.js',{id:b.dataset.key,quantity:+b.dataset.q});if(isCartPage){location.reload();return;}renderCart(await r.json());};
  $('#checkout').onclick=()=>{location.href=ROOT+'checkout';};
  refresh();
}
document.addEventListener('click',e=>{const b=e.target.closest('.quick-add');if(!b)return;e.preventDefault();addToCart(b.dataset.variant,+b.dataset.qty||1);});

// Galeria
let lb;
function openLb(imgs,start){
  if(!lb){
    lb=document.createElement('div');lb.className='gg-lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
    lb.innerHTML=`<button class='gg-lb-close' aria-label='Cerrar'>×</button><button class='gg-lb-prev' aria-label='Anterior'>‹</button><div class='gg-lb-track'></div><button class='gg-lb-next' aria-label='Siguiente'>›</button><div class='gg-lb-count'></div>`;
    document.body.appendChild(lb);
    const t=$('.gg-lb-track',lb);
    const cur=()=>Math.round(t.scrollLeft/t.clientWidth);
    const cnt=()=>{$('.gg-lb-count',lb).textContent=(cur()+1)+' / '+t.children.length;};
    t.addEventListener('scroll',()=>{clearTimeout(t._t);t._t=setTimeout(cnt,60);},{passive:true});
    const close=()=>{lb.classList.remove('open');document.documentElement.style.overflow='';};
    $('.gg-lb-close',lb).onclick=close;
    $('.gg-lb-prev',lb).onclick=()=>t.scrollBy({left:-t.clientWidth,behavior:'smooth'});
    $('.gg-lb-next',lb).onclick=()=>t.scrollBy({left:t.clientWidth,behavior:'smooth'});
    lb.addEventListener('click',e=>{if(e.target.classList.contains('gg-lb-slide'))close();});
    addEventListener('keydown',e=>{if(!lb.classList.contains('open'))return;if(e.key==='Escape')close();if(e.key==='ArrowRight')t.scrollBy({left:t.clientWidth,behavior:'smooth'});if(e.key==='ArrowLeft')t.scrollBy({left:-t.clientWidth,behavior:'smooth'});});
    lb._cnt=cnt;
  }
  const t=$('.gg-lb-track',lb);
  t.innerHTML=imgs.map(i=>`<div class='gg-lb-slide'><img src='${esc(i.src)}' alt='${esc(i.alt)}'></div>`).join('');
  lb.classList.add('open');document.documentElement.style.overflow='hidden';
  requestAnimationFrame(()=>{t.scrollLeft=t.clientWidth*start;lb._cnt();});
}
$$('[data-gallery]').forEach(g=>{
  const track=$('.gg-track',g), slides=$$('.gg-slide',g), thumbs=$$('.gg-thumb',g), count=$('.gg-count',g), pv=$('.gg-prev',g), nx=$('.gg-next',g);
  if(!track||!slides.length)return;
  let idx=0;
  const upd=()=>{
    thumbs.forEach((t,k)=>t.classList.toggle('active',k===idx));
    if(count)count.textContent=(idx+1)+' / '+slides.length;
    if(pv)pv.disabled=idx===0; if(nx)nx.disabled=idx===slides.length-1;
    const t=thumbs[idx];if(t){const s=t.parentElement;s.scrollTo({left:t.offsetLeft-s.clientWidth/2+t.clientWidth/2,behavior:'smooth'});}
    slides.forEach((s,k)=>{const v=s.querySelector('video');if(v&&k!==idx)v.pause();});
  };
  const go=i=>{i=Math.max(0,Math.min(slides.length-1,i));idx=i;upd();track.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'});};
  track.addEventListener('scroll',()=>{clearTimeout(track._t);track._t=setTimeout(()=>{const i=Math.round(track.scrollLeft/track.clientWidth);if(i!==idx){idx=i;upd();}},70);},{passive:true});
  thumbs.forEach((t,k)=>t.addEventListener('click',()=>go(k)));
  if(pv)pv.onclick=()=>go(idx-1); if(nx)nx.onclick=()=>go(idx+1);
  g.addEventListener('keydown',e=>{if(e.key==='ArrowRight')go(idx+1);if(e.key==='ArrowLeft')go(idx-1);});
  const zoomables=slides.filter(s=>s.querySelector('img[data-full]'));
  const imgs=zoomables.map(s=>{const i=s.querySelector('img[data-full]');return {src:i.dataset.full,alt:i.alt};});
  zoomables.forEach((s,k)=>{s.classList.add('zoomable');s.addEventListener('click',()=>openLb(imgs,k));});
  g._go=go;
  upd();
});

// Producto: variantes + packs
$$('[data-gy-product]').forEach(root=>{
  const st={id:root.dataset.variant,price:+root.dataset.price,compare:+root.dataset.compare,available:root.dataset.available==='true',qty:1};
  const tiers=$$('.option',root), addBtn=$('.js-add',root);
  const render=()=>{
    const q=st.qty;
    $('.js-price',root).textContent=money(st.price*q);
    const old=$('.js-old',root), save=$('.js-save',root);
    if(st.compare>st.price){old.textContent=money(st.compare*q);save.textContent='AHORRA '+pctOff(st.price,st.compare)+'%';save.hidden=false;}else{old.textContent='';save.hidden=true;}
    const inst=$('.js-inst',root);if(inst)inst.textContent='o 4 pagos sin intereses de '+money(st.price*q/4);
    tiers.forEach(t=>{const tq=+t.dataset.qty;$('.p',t).textContent=money(st.price*tq);const s=$('.tier-old',t);if(s)s.textContent=st.compare>st.price?money(st.compare*tq):'';});
    if(addBtn){addBtn.disabled=!st.available;addBtn.textContent=st.available?'Añadir al carrito':'Agotado';}
    $$('.js-sticky-price').forEach(e=>e.textContent=money(st.price*q));
    $$('.js-sticky-add').forEach(b=>b.disabled=!st.available);
  };
  const pick=t=>{tiers.forEach(x=>x.classList.remove('selected'));t.classList.add('selected');st.qty=+t.dataset.qty;render();};
  tiers.forEach(t=>{t.addEventListener('click',()=>pick(t));t.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();pick(t);}});});
  $$('.gy-variant',root).forEach(v=>v.addEventListener('click',()=>{
    $$('.gy-variant',root).forEach(x=>x.classList.toggle('active',x===v));
    st.id=v.dataset.id;st.price=+v.dataset.price;st.compare=+v.dataset.compare;st.available=v.dataset.available==='true';
    const g=$('[data-gallery]',root);if(g&&g._go&&v.dataset.media!==undefined&&v.dataset.media!=='')g._go(+v.dataset.media);
    render();
  }));
  if(addBtn)addBtn.addEventListener('click',()=>addToCart(st.id,st.qty));
  $$('.js-sticky-add').forEach(b=>b.addEventListener('click',()=>addToCart(st.id,st.qty)));
  render();
  const sticky=$('#gySticky');
  if(sticky&&addBtn){new IntersectionObserver(es=>es.forEach(e=>{sticky.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);}),{threshold:0}).observe(addBtn);}
});

// Antes / despues
const LINES=[
  'M60 120 q70 -20 140 0 t140 0|M60 170 q70 -20 140 0 t140 0|M60 220 q70 -20 140 0 t140 0|M80 270 q60 -15 120 0 t120 0',
  'M100 140 q100 80 200 0|M90 200 q110 90 220 0|M120 260 q80 50 160 0',
  'M80 150 q60 30 120 0|M90 180 q50 25 100 0|M210 150 q60 30 120 0|M220 180 q50 25 100 0|M100 210 q40 15 80 0|M230 210 q40 15 80 0',
  'M130 200 l-8 -40|M160 205 l-4 -45|M190 207 l0 -48|M220 205 l4 -45|M250 200 l8 -40|M140 260 l-6 30|M200 265 l0 34|M260 260 l6 30'
];
const slider=$('#baSlider');
if(slider){
  const setBA=t=>{
    $('#beforeLines').innerHTML=(LINES[+t.dataset.style]||LINES[0]).split('|').map(d=>`<path d='${d}'/>`).join('');
    $('#tQuote').textContent=t.dataset.quote;$('#tText').textContent=t.dataset.text;$('#tWho').textContent=t.dataset.who;
    $$('.ba-tab').forEach(x=>x.classList.toggle('active',x===t));
  };
  $$('.ba-tab').forEach(t=>t.onclick=()=>setBA(t));
  const first=$('.ba-tab');if(first)setBA(first);
  const move=x=>{const r=slider.getBoundingClientRect();const p=Math.min(100,Math.max(0,(x-r.left)/r.width*100));$('#baAfter').style.clipPath=`inset(0 0 0 ${p}%)`;$('#baHandle').style.left=p+'%';};
  let drag=false;
  slider.addEventListener('pointerdown',e=>{drag=true;slider.setPointerCapture(e.pointerId);move(e.clientX);});
  slider.addEventListener('pointermove',e=>{if(drag)move(e.clientX);});
  slider.addEventListener('pointerup',()=>{drag=false;});
}

// FAQ
$$('.faq-q').forEach(q=>q.onclick=()=>{
  const item=q.parentElement,a=item.querySelector('.faq-a'),open=item.classList.contains('open');
  $$('.faq-item').forEach(i=>{i.classList.remove('open');i.querySelector('.faq-a').style.maxHeight=0;});
  if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
});

// Estadisticas
const sio=new IntersectionObserver(es=>es.forEach(e=>{
  if(!e.isIntersecting)return;
  const num=e.target.querySelector('.num'),ring=e.target.querySelector('.fg'),target=+num.dataset.count;let n=0;
  ring.style.strokeDashoffset=471*(1-target/100);
  const iv=setInterval(()=>{n+=2;if(n>=target){n=target;clearInterval(iv);}num.textContent=n+'%';},30);
  sio.unobserve(e.target);
}),{threshold:.4});
$$('.stat').forEach(s=>sio.observe(s));

// Popup
const popup=$('#popup');
if(popup){
  if(!store.get('gyora-popup-seen')&&!design)setTimeout(()=>popup.classList.add('show'),2500);
  const closePopup=()=>{popup.classList.remove('show');store.set('gyora-popup-seen',true);};
  $('#closePopup').onclick=closePopup;
  popup.onclick=e=>{if(e.target===popup)closePopup();};
  $$('.choice').forEach(c=>c.onclick=()=>{
    const code=popup.dataset.code;
    fetch(ROOT+'discount/'+encodeURIComponent(code)+'?redirect=%2Fcart.js',{credentials:'same-origin'}).catch(()=>{});
    $('#popupBody').innerHTML=`<div class='logo'>GYORA</div><h3>¡Aquí tienes tu <span>${esc(popup.dataset.pct)}</span>!</h3><p>Se aplicará automáticamente en el pago. Tu código:</p><div class='code'>${esc(code)}</div><button class='btn full' id='shopNow'>Comprar ahora</button>`;
    $('#shopNow').onclick=()=>{closePopup();const p=$('#producto');if(p)p.scrollIntoView({behavior:'smooth'});};
  });
}
})();
